import React, { useState, useMemo } from "react";
import { Fragment } from "react";
import { Typography, Grid, Button, useMediaQuery } from "@mui/material";
import { useLocation } from "react-router-dom";
import PersistentDrawerRight from "../common/persistent-drawer-right"; // Import your PersistentDrawerRight component
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useSelector } from "react-redux";
import { loginSelector, selectUser } from "../../redux/selectors/user.selector";
import { Link, useNavigate } from "react-router-dom";
import { useTheme } from "@emotion/react";

const Header = () => {
  const [isHovered, setIsHovered] = useState(false);
  const theme = useTheme();
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const loggedIn = useSelector(loginSelector);
  const userData = useSelector(selectUser);

  const styles = {
    heading: {
      padding: "15px",
    },
    links: {
      padding: "0 0px 0 20px",
      color: "black",
      textDecoration: "none",
    },
  };

  const location = useLocation();
  const colorCode = location.pathname === "/" ? "black" : "white";

  const showDrawer =
    isSmallScreen &&
    location.pathname !== "/sign-in" &&
    location.pathname !== "/sign-up";

  let navbarLabels = [];

  if (loggedIn) {
    navbarLabels = [
      // { label: "Home", url: "/", type: "text" },
      { label: "About Us", url: "/about-us", type: "text" },
      { label: "Contact Us", url: "/contact-us", type: "text" },
      { label: "Pricing", url: "/pricing", type: "text" },
    ];
  } else {
    navbarLabels = [
      // { label: "Home", url: "/", type: "text" },
      { label: "About Us", url: "/about-us", type: "text" },
      { label: "Contact Us", url: "/contact-us", type: "text" },
      { label: "Pricing", url: "/pricing", type: "text" },
      { label: "Login", url: "/login", type: "button" },
      { label: "Try Now", url: "/sign-up", type: "button" },
    ];
  }

  return (
    <Fragment>
      <Grid
        container
        justifyContent={"space-between"}
        alignItems="center"
        style={styles.heading}
      >
        <Grid item xs={12} md={3}>
          <Link to="/" style={{ textDecoration: "none" }}>
            <Typography variant="h5" color="primary">
              ACC Copilot for WhatsApp
            </Typography>{" "}
          </Link>
        </Grid>

        <Grid item xs={12} md={9}>
          {showDrawer ? (
            <PersistentDrawerRight
              title={
                <Link
                  to="/"
                  style={{
                    textDecoration: "none",
                    color: `${theme.palette.primary.main}`,
                  }}
                >
                  ACC Copilot for WhatsApp
                </Link>
              }
              navbarLabels={navbarLabels}
            />
          ) : (
            <Grid container justifyContent="flex-end" alignItems={"center"}>
              {navbarLabels.map((navItem, index) => {
                if (navItem.type === "text") {
                  return (
                    <Link
                      key={index}
                      to={navItem.url}
                      style={{ ...styles.links, color: colorCode }}
                    >
                      {navItem.label}
                    </Link>
                  );
                } else {
                  return (
                    <Button
                      key={index}
                      onClick={() => navigate(navItem.url)}
                      style={{
                        ...styles.links,
                        color: colorCode,
                        border: `1px solid ${colorCode}`,
                        borderRadius: "20px",
                        padding: "8px 16px",
                        transition: "all 0.2s ease",
                        color: isHovered ? "white" : colorCode,
                        marginLeft: "20px",
                      }}
                    >
                      {navItem.label}
                    </Button>
                  );
                }
              })}
              {loggedIn && (
                <>
                  <Link
                    id="basic-button"
                    to={"/account"}
                    style={{ ...styles.links, color: colorCode }}
                  >
                    {userData && userData.profilePicture ? (
                      <img
                        src={userData.profilePicture}
                        alt="user img"
                        width={35}
                        style={{ borderRadius: "50%" }}
                      />
                    ) : (
                      <AccountCircleIcon style={{ fontSize: "2rem" }} />
                    )}
                  </Link>
                </>
              )}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default Header;
